export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10530.1b002a9c.jpg";